import ErrorBoundry from './error-boundry';

export default ErrorBoundry;



// WEBPACK FOOTER //
// ./src/components/error-boundry/index.js